<template>
    <transition name="fade">
        <div v-show="show" class="box">
            
            <div class="NoClick" v-show="type == 'loading'"> </div>

            <div class="toastMessageBox">
                <img v-show="type == 'success'"
                    src="//image.gamersky.com/webimg13/zhuanti/2023NewYearActivity/toastSucess.png" />
                <img v-show="type == 'error'" src="//image.gamersky.com/webimg13/zhuanti/2022NewYear/toastError.png" />
                <img class="loading" v-show="type == 'loading'"
                    src="//image.gamersky.com/webimg13/zhuanti/valorantskin/loading.png" />
                <div v-html="message"></div>
            </div>
        </div>

    </transition>
</template>

<script>
export default {
    name: "toastMessage",
    data() {
        return {
            message: "",
            show: false,
            type: "info",
        };
    },
};
</script>

<style lang="scss" scoped>

.NoClick {
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    // background: rgba(0, 0, 0, 0.8);
    z-index: 99;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
    z-index: 100000;
    position: relative;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
    z-index: 100000;
     position: relative;
}

.toastMessageBox {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: fixed;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 16px;
    font-size: 14px;
    border-radius: 6px;
    text-align: center;
    z-index: 100000;
    width: 140px;
    min-height: 90px;
    box-sizing: border-box;

    img {
        display: block;
        width: 28px;
        height: 28px;
        object-fit: cover;
        margin-bottom: 8px;

        &.loading {
            animation: loading 1s linear infinite;
        }
    }
}

@keyframes loading {
    from {
        transform: rotateZ(0deg) rotateY(180deg);
    }

    to {
        transform: rotateZ(360deg) rotateY(180deg);
    }
}
</style>
